import { ConfigProps } from '@config/types'

const config = ({ staticAssetPageUrl, staticPageUrlSuffix }: ConfigProps) => ({
  widgetUrl: `${staticAssetPageUrl}/riddle${staticPageUrlSuffix}`,
})

export type configType = ReturnType<typeof config>
export default config
